import staticQueryData from "../../../../public/static/d/3479325432.json";
import React from 'react';
import { StaticQuery } from 'gatsby';
import Seo from './Seo';
var QUERY = "3479325432";
export function Head(_ref) {
  var pageContext = _ref.pageContext;
  return React.createElement(StaticQuery, {
    query: QUERY,
    render: function render(data) {
      return React.createElement(Seo, {
        title: pageContext.frontmatter.title + " - " + data.site.siteMetadata.title
      });
    },
    data: staticQueryData
  });
}